export enum SimpleFieldType {
    Undefined = 0,
    StringField = 1,
    NumericField = 2,
    DateTimeField = 3,
    DateTimeOffSetField = 4,
    BooleanField = 5,
    GuidField = 6,
    EnumField = 7
}